/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useState } from "react";
import { ExpandLess, ExpandMore, StarBorder } from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse";
import ListItemIcon from '@material-ui/core/ListItemIcon';

const useStyles = makeStyles(styles);

const useNestStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(2),
    },
}));

export default function Sidebar(props) {
    const classes = useStyles();
    const nestClasses = useNestStyles();

    // verifies if routeName is the one active (in browser input)
    function activeRoute(routeName) {
        return window.location.href.indexOf(routeName) > -1 ? true : false;
    }
    const { color, logo, image, logoText, routes } = props;
    var links = (
        <List className={classes.list}>
            {routes.map((prop, key) => {
                
                var listItemClasses = classNames({
                    [" " + classes[color]]: activeRoute(prop.layout + prop.path)
                });

                const whiteFontClasses = classNames({
                    [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
                });

                if (prop.group) {
                    const [open, setOpen] = useState(false);
                    const handleOpen = () => {
                        setOpen(!open)
                    }

                    return (
                        <List component="div"
                            className={classes.item}
                            disablePadding={true}
                            key={key}
                        >
                            <ListItem button
                                className={classes.itemLink + listItemClasses}
                                style={{ display: "flex" }}
                                onClick={handleOpen}>
                                {typeof prop.icon === "string" ? (
                                    <Icon
                                        className={classNames(classes.itemIcon, whiteFontClasses, {
                                            [classes.itemIconRTL]: props.rtlActive
                                        })}
                                    >
                                        {prop.icon}
                                    </Icon>
                                ) : (
                                        <prop.icon
                                            className={classNames(classes.itemIcon, whiteFontClasses, {
                                                [classes.itemIconRTL]: props.rtlActive
                                            })}
                                        />
                                    )}
                                <ListItemText
                                    primary={prop.name}
                                    disableTypography={true}
                                    className={classNames(classes.itemText, whiteFontClasses, {
                                        [classes.itemTextRTL]: props.rtlActive
                                    })}
                                />
                                {open ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <List disablePadding className={nestClasses.nested}>
                                    {prop.group.map((childProp, childKey) => {
                                         var childItemActiveClasses = classNames({
                                            [" " + classes[color]]: activeRoute(childProp.layout + childProp.path)
                                        });
                                        return (
                                            <NavLink
                                                to={childProp.layout + childProp.path}
                                                className={classes.item}
                                                activeClassName="active"
                                                key={childKey}
                                            >
                                                <ListItem button className={classes.itemLink + childItemActiveClasses}>
                                                    {childProp.icon ? <childProp.icon
                                                        className={classNames(classes.itemIcon, whiteFontClasses, {
                                                            [classes.itemIconRTL]: props.rtlActive
                                                        })}
                                                    />: null}
                                                    
                                                    <ListItemText
                                                        primary={childProp.name}
                                                        className={classNames(classes.itemText, whiteFontClasses, {
                                                            [classes.itemTextRTL]: props.rtlActive
                                                        })}
                                                        disableTypography={true}
                                                    />
                                                </ListItem>
                                            </NavLink>
                                        )
                                    })}

                                </List>
                            </Collapse>
                        </List>
                    )
                } else {
                    return (
                        <NavLink
                            to={prop.layout + prop.path}
                            className={classes.item}
                            activeClassName="active"
                            key={key}
                        >
                            <ListItem button className={classes.itemLink + listItemClasses}>
                                {typeof prop.icon === "string" ? (
                                    <Icon
                                        className={classNames(classes.itemIcon, whiteFontClasses, {
                                            [classes.itemIconRTL]: props.rtlActive
                                        })}
                                    >
                                        {prop.icon}
                                    </Icon>
                                ) : (
                                        <prop.icon
                                            className={classNames(classes.itemIcon, whiteFontClasses, {
                                                [classes.itemIconRTL]: props.rtlActive
                                            })}
                                        />
                                    )}
                                <ListItemText
                                    primary={props.rtlActive ? prop.rtlName : prop.name}
                                    className={classNames(classes.itemText, whiteFontClasses, {
                                        [classes.itemTextRTL]: props.rtlActive
                                    })}
                                    disableTypography={true}
                                />
                            </ListItem>
                        </NavLink>
                    )
                }
            })}
        </List>
    );
    var brand = (
        <div className={classes.logo}>
            <a
                href="#"
                className={classNames(classes.logoLink, {
                    [classes.logoLinkRTL]: props.rtlActive
                })}
            >
                <div className={classes.logoImage}>
                    <img src={logo} alt="logo" className={classes.img} />
                </div>
                {logoText}
            </a>
        </div>
    );
    return (
        <div>
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={props.rtlActive ? "left" : "right"}
                    open={props.open}
                    classes={{
                        paper: classNames(classes.drawerPaper, {
                            [classes.drawerPaperRTL]: props.rtlActive
                        })
                    }}
                    onClose={props.handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile.
                    }}
                >
                    {brand}
                    <div className={classes.sidebarWrapper}>
                        {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
                        {links}
                    </div>
                    {image !== undefined ? (
                        <div
                            className={classes.background}
                            style={{ backgroundImage: "url(" + image + ")" }}
                        />
                    ) : null}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    anchor={props.rtlActive ? "right" : "left"}
                    variant="permanent"
                    open
                    classes={{
                        paper: classNames(classes.drawerPaper, {
                            [classes.drawerPaperRTL]: props.rtlActive
                        })
                    }}
                >
                    {brand}
                    <div className={classes.sidebarWrapper}>{links}</div>
                    {image !== undefined ? (
                        <div
                            className={classes.background}
                            style={{ backgroundImage: "url(" + image + ")" }}
                        />
                    ) : null}
                </Drawer>
            </Hidden>
        </div>
    );
}

Sidebar.propTypes = {
    rtlActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
    logo: PropTypes.string,
    image: PropTypes.string,
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool
};
